<template>
    <div class="ma-4">

        <v-col cols="9" sm="3" md="3">
            <v-menu
                ref="clockInOutDateFilterMenu"
                v-model="clockInOutDateFilterMenu"
                :close-on-content-click="false"
                :return-value.sync="clockInOutDateFilter"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="clockInOutDateFilter"
                        label="Filter by Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        :disabled="isLoadingClockInOutTable"
                    ></v-text-field>
                </template>
                <v-date-picker
                    v-model="clockInOutDateFilter"
                    scrollable
                >
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        @click="clockInOutDateFilterMenu = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        text
                        color="primary"
                        @click="$refs.clockInOutDateFilterMenu.save(clockInOutDateFilter), getAllTimeSheetsByStateByProgram()"
                    >
                        OK
                    </v-btn>
                </v-date-picker>
            </v-menu>
        </v-col>
        <!--<v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>-->
        <v-data-table
          fixed-header
          height="550px"
          width="600"
          class="mx-auto"
          :headers="clockInListHeaders"
          :items="clockInOutList"
          :loading="isLoadingClockInOutTable"
      >
          
          <template
              v-slot:body="{ items }"
          >
              <tbody>
                  <tr
                      v-for="item in items"
                      :key="item._id"
                  >
                      <td>{{ item.Employee.Name }}</td>
                      <td>{{ item.ScheduleDate  }}</td>
                      <td>{{ item.locationLogin  }}</td>
                      <td class="text-center">
                        {{ isClockTypeStatus(item) == "No Clock In" ?  " - - - " : item.ClockIn }}
                      </td>
                      <td class="text-center">{{ isClockTypeStatus(item) }}</td>
                      <td class="text-center">
                          {{ isClockOutTypeStatus(item) == "No Clock Out" ?  " - - - " : item.ClockOut }}
                      </td>
                      <td class="text-center">{{ isClockOutTypeStatus(item) }}</td>
                  </tr>
              </tbody>
          </template>
        </v-data-table>
        <Foot/>
    </div>
</template>

<!--
<template>
  <div class="ma-4">
    <v-list disabled>
      <v-subheader>NOTIFICATIONS</v-subheader>
      <v-list-item-group v-model="item" color="primary">
        <v-list-item v-for="(item, index) in notificationsAll" :key="index">
          <v-list-item-main>
            <v-list-item-title v-text="item.Title"></v-list-item-title>
            <v-list-item-subtitle v-html="item.Description"></v-list-item-subtitle>
          </v-list-item-main>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>
-->
<script>
    import axios from 'axios'
    import moment from 'moment';
    import Foot from '../components/Footer'

    import {mapGetters} from "vuex";

    import {setUserTz} from "../../utils/timezone";

    const url = require("../client_config/config").url;


    export default {
        components: {
            Foot,
        },
        data: function () {
            return {
                userState: localStorage.getItem('userState'),
                userPrograms: localStorage.getItem('userPrograms'),
                userProgramsList: [],
                clockInOut_NotifBtn: false,
                isShowClockInOutNotifBtn: false,
                clockInOutList: [],
                changeClockType: true,
                isLoadingClockInOutTable: true,
                clockInOutDateFilterMenu: false,
                clockInOutDateFilter: moment(new Date()).format("YYYY-MM-DD"),
                clockInOutBadgeFlag: {
                    in: 0,
                    out: 0,
                    sum: 0
                },
                clockInListHeaders: [
                  {
                      text: 'Name',
                      align: 'start',
                      sortable: true,
                      value: 'Employee.Name',
                      filterable: false,
                  },
                  { text: 'Schedule', align: 'center', value: 'ClockInSchedule' },
                  { text: 'Location', align: 'center', value: 'locationLogin' },
                  { text: 'Clocked In', align: 'center', value: 'ClockIn', filterable: false, },
                  { text: 'Clocked In Status', align: 'center', sortable: false, filterable: false, },
                  { text: 'Clocked Out', align: 'center', value: 'ClockOut', filterable: false, },
                  { text: 'Clocked In Status', align: 'center', sortable: false, filterable: false, },
              ],
              clockOutListHeaders: [
                  {
                      text: 'Name',
                      align: 'start',
                      sortable: false,
                      value: 'Employee.Name',
                      filterable: false,
                  },
                  { text: 'End', align: 'center', value: 'ClockOutSchedule' },
                  { text: 'Time Clocked Out', align: 'center', value: 'ClockOut', filterable: false, },
                  { text: 'Status', align: 'center', sortable: false, filterable: false, },
              ],
            };
        },
        computed: {

          ...mapGetters({
              getUserTimezone: "timezones/getUserTimezone",
              getDefaultTz: "timezones/getDefaultTz",
          }),

          userTimezone() {
              const data = {
                  userTimezone: this.getUserTimezone,
                  defaultTz: this.getDefaultTz,
              };
              return setUserTz(data);
          },
        },

        watch: {
            options: {
                handler() {
                    this.getAllNotifications();
                },
                deep: true
            },
        },

        async created() {
            this.userProgramsList = this.userPrograms ? JSON.parse(this.userPrograms) : [];
            this.getAllTimeSheetsByStateByProgram();
        },

        methods: {

          async getAllTimeSheetsByStateByProgram () {
            this.isLoadingClockInOutTable = true;
            this.clockInOutBadgeFlag.in = 0;
            this.clockInOutBadgeFlag.out = 0;
            this.clockInOutBadgeFlag.sum = 0;

            const dateFilter = moment.utc(this.clockInOutDateFilter).format("YYYY-MM-DD");

            const params = {
              timezone: this.userTimezone
            };

            await axios.get(`${url}/timeSheets/clockTracker/${this.userState}/${this.userProgramsList.toString()}/${dateFilter}`, {params}).then(res => {
             
                this.clockInOutList = res.data

                this.clockInOutList.map(timeSheet => {
                    timeSheet.locationLogin = "";
                      //geolocation
                    if (
                        timeSheet.GeolocationIn != undefined ||
                        timeSheet.GeolocationIn.length > 0
                    ) {
                      timeSheet.GeolocationIn.forEach((val) => {
                        timeSheet.locationLogin =
                            val["Street"] +
                            ", " +
                            val["City"] +
                            ", " +
                            val["Country"];
                      });
                    }
                    timeSheet.ScheduleDate = moment(timeSheet.ClockInSchedule).format("YYYY-MM-DD");
                    timeSheet.ClockInSchedule = moment(timeSheet.ClockInSchedule).format("YYYY-MM-DD hh:mm A");
                    timeSheet.ClockOutSchedule = moment(timeSheet.ClockOutSchedule).format("YYYY-MM-DD hh:mm A");

                    timeSheet.ClockIn = moment(timeSheet.ClockIn).format("YYYY-MM-DD hh:mm A");
                    timeSheet.ClockOut = moment(timeSheet.ClockOut).format("YYYY-MM-DD hh:mm A");

                    if (timeSheet.Shift.isRecurringEvent === "No") {
                        if (timeSheet.Shift.isClockIn && timeSheet.Late > 0) {
                            this.clockInOutBadgeFlag.in++
                        } else if (!timeSheet.Shift.isClockIn) {
                            this.clockInOutBadgeFlag.in++
                        }

                        !timeSheet.Shift.isClockOut ? this.clockInOutBadgeFlag.out++ : this.clockInOutBadgeFlag.out;
                    } else if (timeSheet.Shift.isRecurringEvent === "Yes") {
                        let recurringDatesSchedulesIn = timeSheet.Shift.recurringDatesClockIn == undefined ? [] : timeSheet.Shift.recurringDatesClockIn
                        if (recurringDatesSchedulesIn.length > 0) {
                            recurringDatesSchedulesIn.forEach(sched => {
                                if (sched.timeSheetId === timeSheet._id) {
                                    if (sched.isClockIn && timeSheet.Late > 0) {
                                        this.clockInOutBadgeFlag.in++
                                    } else if (!sched.isClockIn || sched.isClockOut == undefined) {
                                        this.clockInOutBadgeFlag.in++
                                    } else if (sched == undefined || sched.recurringDatesSchedules == undefined) {
                                        this.clockInOutBadgeFlag.in++
                                    }
                                }
                            })
                        } else {
                            this.clockInOutBadgeFlag.in++
                        }

                        let recurringDatesSchedulesOut = timeSheet.Shift.recurringDatesClockOut == undefined ? [] : timeSheet.Shift.recurringDatesClockOut
                        if (recurringDatesSchedulesOut.length > 0) {
                            recurringDatesSchedulesOut.forEach(sched => {
                                if (sched.timeSheetId === timeSheet._id) {
                                    if (!sched.isClockOut || sched.isClockOut == undefined) {
                                        this.clockInOutBadgeFlag.out++
                                    } else if (sched == undefined || sched.recurringDatesSchedules == undefined) {
                                        this.clockInOutBadgeFlag.out++
                                    }
                                }
                            })
                        } else {
                            this.clockInOutBadgeFlag.out++
                        }
                    }
                })

                this.clockInOutBadgeFlag.sum = this.clockInOutBadgeFlag.in + this.clockInOutBadgeFlag.out;
            }).finally(() => {
                this.delPastSched_btn = false;
                this.loadPastSched_btn = false;
                this.isLoadingClockInOutTable = false;
            })
          },

          isClockTypeStatus (item) {
            if (item.Shift.isRecurringEvent === "No") {
                if (item.Shift.isClockIn && item.Late == 0) {
                    return "Clock In"
                } else if (item.Shift.isClockIn && item.Late > 0) {
                    return "Late"
                } else if (!item.Shift.isClockIn) {
                    return "No Clock In"
                }
            } else if (item.Shift.isRecurringEvent === "Yes") {
                let recurringDatesSchedules = item.Shift.recurringDatesClockIn
                let toReturnValue = ""

                recurringDatesSchedules.forEach(sched => {
                    if (sched.timeSheetId === item._id) {
                        if (sched.isClockIn && item.Late == 0) {toReturnValue = "Clock In"}
                        else if (sched.isClockIn && item.Late > 0) {toReturnValue = "Late"}
                        else if (!sched.isClockIn || sched.isClockIn === null) {toReturnValue = "No Clock In"}
                    }
                })
                
                let clockIn = recurringDatesSchedules.find(sched => sched.timeSheetId === item._id)
                clockIn === undefined ? toReturnValue = "No Clock In" : toReturnValue
                
                return toReturnValue
            }
          },

          isClockOutTypeStatus (item) {
            
            if (item.Shift.isRecurringEvent === "No") {
                return item.Shift.isClockOut ? "Clock Out" : "No Clock Out"
            } else if (item.Shift.isRecurringEvent === "Yes") {
                let recurringDatesSchedules = item.Shift.recurringDatesClockOut
                let toReturnValue = ""

                recurringDatesSchedules.forEach(sched => {
                    if (sched.timeSheetId === item._id) {
                        if (sched.isClockOut) {toReturnValue = "Clock Out"}
                        else if (!sched.isClockOut || sched.isClockOut === null) {toReturnValue = "No Clock Out"}
                    }
                })

                let clockOut = recurringDatesSchedules.find(sched => sched.timeSheetId === item._id)
                clockOut === undefined ? toReturnValue = "No Clock Out" : toReturnValue

                return toReturnValue
            }
            
          },


        },

        

    };

</script>
